import { trackEvent } from '@/entities/sogu';
import { tourMapFilterDataToSogu, useTourFiltersStore } from '@/entities/filter/store/tour';
import type { ContextGeoSubject } from '@/shared/types/geography.ts';
import { useTourSoguStore } from '@/features/sogu/store/tour/useTourSoguStore.ts';
import { removeNullableProperties } from '@/shared/lib/removeNullableProperties.ts';

export function useTourSortingClickTracker() {
  const filtersStore = useTourFiltersStore();
  const soguStore = useTourSoguStore();

  const trackSortingClick = (defaultSoguFields: ContextGeoSubject) => {
    trackEvent('listing:sorting.click', {
      ...defaultSoguFields.soguStamp,
      ...removeNullableProperties(tourMapFilterDataToSogu(filtersStore.state)),
      tag_id: soguStore.rubricId,
      filter_window_type: 'manual_listing_open_popup',
      total_experiences: soguStore.totalExperiences,
      filtered_experiences: soguStore.filteredExperiences,
    });
  };

  return {
    trackSortingClick,
  };
}
